export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '绿途币发放登记列表';
